<template>
  <v-text-field
    ref="input"
    class="white inline-error"
    style="width: 106px;"
    outlined persistent-hint persistent-placeholder placeholder="h:mm"
    :hint="hint"
    :label="label"
    :rules="[ validate ]"
    :disabled="disabled"
    :dense="dense"
    v-model="hmm"
    @click.native="highlight"
  >
    <template v-slot:append>
      <v-btn
        v-if="hour12"
        class="px-2 am-pm"
        v-bind:class="{ 'not-selected': !a }"
        absolute text
        :small="dense"
        :disabled="disabled"
        @click="a = ((a == 'PM') ? 'AM' : 'PM'); $refs.input.validate();"
        @keydown="
          e => {
            if ([ 13, 32, 37, 38, 39, 40, 65, 80 ].includes(e.keyCode)) {
              e.stopPropagation();
              e.preventDefault();
              if (e.keyCode == 65)
                a = 'AM';
              else if (e.keyCode == 80)
                a = 'PM';
              else
                a = ((a == 'PM') ? 'AM' : 'PM');
              $refs.input.validate();
            }
          }
        "
      >
        {{a || '--'}}
      </v-btn>
    </template>
  </v-text-field>
</template>


<style scoped>
.am-pm {
  min-width: unset !important;
  color: inherit;
  font-size: inherit;
  letter-spacing: normal;
  top: 6px;
  right: 6px;
  width: 42px;
}
.v-input--has-state .am-pm.not-selected {
  background-color: rgb(255, 82, 82, .2);
}
</style>


<script>
import { format, getUTCOffset, getTimezoneName, getOrdinalSuffixEN } from '@/utils/time.js';
import { mdiCalendar } from '@mdi/js';

export default {
  name: 'input-time',

  props: {
    value: String, // A 24-hour ISO time string like "13:30"
    label: String,
    hint: String,
    disabled: Boolean,
    rules: Array,
    dense: Boolean
  },

  data() {
    return {
      hmm: null,
      a: null,
      hour12: Intl.DateTimeFormat(navigator.language, { hour: 'numeric' }).resolvedOptions().hour12
    };
  },

  computed: {
    components() {
      return [ this.hmm, this.a ];
    },

    regex() {
      return this.hour12 ? /^((1[0-2])|[1-9])([-:,\.; ][0-5]\d)?$/ : /^(2[0-3]|[01]?[0-9])([-:,\.; ][0-5]\d)?$/;
    }
  },

  methods: {
    highlight() {
      const el = this.$el.querySelector('input[type=text]');
      if (el.value)
        el.setSelectionRange(0, el.value.length);
    },

    validate(v, ignoreRules=false) {
      if (v && !this.regex.test(v))
        return false;
      if (v && this.hour12 && !this.a)
        return false;
      if (!ignoreRules)
        for (const rule of (this.rules || [])) {
          const r = rule(v);
          if (r != true)
            return r;
        }
      return true;
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        if (this.ignore) {
          this.ignore = false;
          return true;
        }
        if (v) {
          const [ hh, mm ] = v.split(':');
          const h = parseInt(hh);
          this.hmm = `${this.hour12 ? ((h % 12) || 12) : hh}:${mm}`;
          this.a = (h < 12) ? 'AM' : 'PM';
        } else {
          this.hmm = null;
        }
      }
    },

    components([ hmm, a ]) {
      if (!this.validate(hmm, true))
        return;
      let value = null;
      if (hmm && (!this.hour12 || a)) {
        const [ h, mm ] = (hmm + (hmm.includes(':') ? '' : ':00') + ':00').split(/\D/);
        const hInt = parseInt(h);
        const hh = (this.hour12 && (((a == 'AM') && (hInt == 12)) || ((a == 'PM') && (hInt < 12)))) ? ((hInt + 12) % 24) : h;
        value = `${String(hh).padStart(2, '0')}:${mm}:00`;
      }
      this.ignore = true;
      this.$emit('input', value);
      this.$nextTick(() => this.ignore = false);
    }
  }
}
</script>
